(() => {
  const selector = 'media-gallery .olayz-inline-video video';
  const prepared = new WeakSet();
  const pending = new WeakSet();
  const observed = new Set();
  let frame = 0;
  function visible(video) {
    if (document.hidden || !video.isConnected || video.closest('[hidden]')) return false;
    const dialog = video.closest('dialog');
    if (dialog && !dialog.open) return false;
    const slide = video.closest('slideshow-slide, .dialog-zoomed-gallery > li, .media-gallery__grid > li');
    const scroller = slide?.closest('slideshow-slides, .dialog-zoomed-gallery, .media-gallery__grid');
    if (!slide || !scroller) return false;
    const a = slide.getBoundingClientRect(), b = scroller.getBoundingClientRect();
    return a.width > 0 && a.height > 0 &&
      Math.min(a.right, b.right, innerWidth) - Math.max(a.left, b.left, 0) > Math.min(a.width, b.width) * 0.25 &&
      Math.min(a.bottom, b.bottom, innerHeight) - Math.max(a.top, b.top, 0) > 2;
  }
  function reveal(video) {
    if (video.readyState >= 2) video.closest('.olayz-inline-video')?.classList.add('olayz-video-ready');
  }
  const observer = new IntersectionObserver(schedule, { threshold: [0, 0.25, 0.5, 0.75] });
  function prepare(video) {
    if (prepared.has(video)) return;
    prepared.add(video);
    observed.add(video);
    observer.observe(video);
    video.muted = video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.preload = 'auto';
    video.addEventListener('playing', () => {
      reveal(video);
      if (!visible(video)) video.pause();
    });
    video.addEventListener('loadeddata', () => { reveal(video); schedule(); });
    video.addEventListener('canplay', schedule);
    video.addEventListener('pause', schedule);
    video.addEventListener('error', () => { video.controls = true; });
    if (video.networkState === 0) video.load();
    reveal(video);
  }
  function sync() {
    frame = 0;
    for (const video of observed) {
      if (!video.isConnected) {
        video.pause();
        observer.unobserve(video);
        observed.delete(video);
      }
    }
    document.querySelectorAll(selector).forEach(video => {
      prepare(video);
      if (!visible(video)) {
        if (!video.paused) video.pause();
        return;
      }
      if (!video.paused || pending.has(video)) return;
      pending.add(video);
      const attempt = video.play();
      if (attempt) attempt.then(() => {
        if (!visible(video)) video.pause();
        else { video.controls = false; reveal(video); }
      }).catch(() => { if (visible(video)) video.controls = true; })
        .finally(() => pending.delete(video));
      else pending.delete(video);
    });
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(sync);
  }
  ['scroll', 'scrollend', 'slideshow:select', 'visibilitychange', 'pageshow']
    .forEach(type => document.addEventListener(type, schedule, { capture: true, passive: true }));
  ['pointerup', 'touchend', 'click']
    .forEach(type => document.addEventListener(type, sync, { capture: true, passive: true }));
  window.addEventListener('resize', schedule, { passive: true });
  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden', 'hidden', 'open']
  });
  schedule();
})();
